import { library } from "@fortawesome/fontawesome-svg-core";
import {
  fab,
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faBars,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  fab,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faBars,
  faWindowClose,
  faFacebookF,
  faInstagram,
  faTwitter
);
